import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_ROUTES as SETTINGS } from "@/Generated/Routes/paths";

const legalAgreements: RouteRecordRaw[] = [
  {
    ...SETTINGS.agreements.root,
    component: () => import("@/Views/settings/agreements/index.vue"),
    meta: {
      sidebar: false,
      i18nTitle: "settings.legal_agreements-title",
    },
  },
  {
    ...SETTINGS.agreements.view.root,
    component: () => import("@/Views/settings/agreements/LegalAgreementView.vue"),
    meta: {
      sidebar: false,
      i18nTitle: "settings.legal_agreements-title",
    },
  },
];

export default legalAgreements;
